import { StandingsViews } from '../../consts';
import { StandingsViewType } from '../../enums';
import { StandingsSeason } from '../../types';
import { isValidViewForSeason } from '../../utils';

type ValidViewsReferenceType = {
    conference?: StandingsViewType;
    division?: StandingsViewType;
    league?: StandingsViewType;
    wildcard?: StandingsViewType;
};

export const getSortedViewTabs = (season: StandingsSeason, wildcardIndicator: boolean): Array<StandingsViewType> => {
    // the purpose is to sort the standings view tabs based on the wildcardIndicator
    // in the event that we're showing wildcard by default (meaning the wildcardIndicator is true), sort wildcard in front of the other view tabs
    // otherwise, if wildcardIndicator is false, sort the division in front of the other view tabs

    // first, filter to only display valid view tabs for the season
    const validViews: Array<StandingsViewType> = Object.keys(StandingsViews).filter((viewType: StandingsViewType) =>
        isValidViewForSeason(viewType, season)
    ) as Array<StandingsViewType>;

    const validViewsReference: ValidViewsReferenceType = {};

    validViews.forEach((view: StandingsViewType) => {
        validViewsReference[view] = view;
    });

    const sortedViews: Array<StandingsViewType> = [];

    // if we're showing wildcard by default, ensure that the wildcard view exists for the season, and if so, sort it to the front of the other view tabs
    if (wildcardIndicator && validViewsReference.wildcard) {
        const { wildcard, ...rest } = validViewsReference;

        sortedViews.push(wildcard);
        sortedViews.push(...Object.values(rest));

        return sortedViews;
    }

    // otherwise, as long as the division view exists for the season, sort division to the front of the other view tabs
    if (validViewsReference.division) {
        const { division, ...rest } = validViewsReference;

        sortedViews.push(division);
        sortedViews.push(...Object.values(rest));

        return sortedViews;
    }

    // otherwise, just leave the view tabs unsorted
    return validViews;
};
